import { View, Text, Modal, StyleSheet, Pressable } from "react-native";
import variables from "src/common/assets/variables";
import { FontAwesome } from "@expo/vector-icons";
import { useDispatch } from "react-redux";
import { clearToken } from "toolkit/features/auth";
import translate from "libs/locale";
import { DEBOUNCE_CALL } from "libs/utils/constants";

const ContextModal = ({ visible, setVisible }) => {
  const dispatch = useDispatch();
  const logout = () => {
    setVisible(false);
    // todo, replace timeout
    setTimeout(() => {
      dispatch(clearToken());
    }, DEBOUNCE_CALL);
  };
  return (
    <View style={styles.centeredView}>
      <Modal
        animationType="slide"
        transparent={true}
        visible={visible}
        onRequestClose={() => {
          setVisible(!visible);
        }}
      >
        <View style={styles.centeredView}>
          <View style={styles.modalView}>
            <View style={styles.closeBtn}>
              <Pressable onPress={() => setVisible(false)}>
                <FontAwesome name="times" size={22} color={variables.$danger} />
              </Pressable>
            </View>
            {/* <Text style={styles.modalText}>More Options...</Text> */}
            <Pressable
              style={[styles.button, styles.buttonClose]}
              onPress={logout}
            >
              <Text style={styles.textStyle}>{translate("logout")}</Text>
            </Pressable>
          </View>
        </View>
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    // backgroundColor: "rgba(0,0,0,0.7)",
  },
  modalView: {
    width: "80%",
    backgroundColor: "white",
    borderRadius: 20,
    padding: 30,
    // alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  button: {
    borderRadius: 20,
    padding: 10,
    elevation: 3,
    shadowOpacity: 0.25,
    shadowRadius: 4,
    width: 120,
  },
  buttonClose: {
    backgroundColor: variables.$brandColor,
    alignSelf: "center",
  },
  closeBtn: {
    position: "absolute",
    right: 0,
    top: -40,
    backgroundColor: "white",
    height: 32,
    width: 32,
    borderRadius: 32,
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    elevation: 3,
    shadowOpacity: 0.25,
    shadowRadius: 4,
  },
  textStyle: {
    color: "white",
    fontWeight: "bold",
    textAlign: "center",
  },
  modalText: {
    marginBottom: 15,
    textAlign: "center",
  },
});

export default ContextModal;
